import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const CustomSelectField = ({
  margin,
  onChange,
  value,
  defaultValues,
  title,
  id,
  disabled,
}) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };
  return (
    <FormControl fullWidth margin={margin} disabled={disabled}>
      <InputLabel id={id + '-label'}>{title}</InputLabel>
      <Select
        labelId={id + '-label'}
        id={id + '-select'}
        value={value}
        label={title}
        variant="outlined"
        onChange={handleChange}
      >
        {defaultValues.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelectField;
